import { useAtom, useAtomValue } from 'jotai';
import { Stack, Text } from '@pairy/pds-react';
import { useMemo, useState } from 'react';

import { PlanItemType } from '@/hooks/queries/pay/usePayPlan';

import { PricePlanInfoAtom, SelectedPlanAtom } from '../index.atom';

import * as Styled from './index.styles';

const PricePlanList = () => {
  const pricePlanInfo = useAtomValue(PricePlanInfoAtom);
  const selectedPlan = useAtomValue(SelectedPlanAtom);
  const [selectedPlanItem, setSelectedPlanItem] = useAtom(SelectedPlanAtom);

  const [planType, setPlanType] = useState<'monthly' | 'yearly'>('monthly');

  const selectedPricePlanList = useMemo(() => {
    const filteredPricePlanList =
      pricePlanInfo &&
      pricePlanInfo
        .filter((item) => item.type == planType)
        .map((item) => {
          if (item.name === 'Pro Plus') {
            return {
              ...item,
              name: 'Pro +',
            };
          }
          return item;
        });

    return planType === 'yearly'
      ? filteredPricePlanList?.map((item) => {
          return {
            ...item,
            price: item.price / 12,
          };
        })
      : filteredPricePlanList;
  }, [planType, pricePlanInfo, selectedPlan]);

  const generatePlanClassName = (item: PlanItemType) => {
    if (item.status === 'same' || item.status === 'next') {
      return 'is-disabled';
    }
    return selectedPlanItem?.id === item.id ? 'is-active' : '';
  };

  return (
    <>
      <Stack gap={16} direction="column" padding={16}>
        <Stack gap={4} justifyContent="center">
          <Styled.PlanTypeButton
            type="button"
            className={planType === 'monthly' ? 'is-active' : ''}
            onClick={(e) => {
              e.stopPropagation();
              setPlanType('monthly');
              setSelectedPlanItem(null);
            }}
          >
            월간 결제
          </Styled.PlanTypeButton>
          <Styled.PlanTypeButton
            type="button"
            className={planType === 'yearly' ? 'is-active' : ''}
            onClick={(e) => {
              e.stopPropagation();
              setPlanType('yearly');
              setSelectedPlanItem(null);
            }}
          >
            연간 결제
          </Styled.PlanTypeButton>
        </Stack>

        <Stack gap={8} direction="column">
          {selectedPricePlanList &&
            selectedPricePlanList.map((item) => {
              return (
                <Styled.PlanWrapper
                  className={generatePlanClassName(item)}
                  key={item.id}
                  padding={16}
                  gap={16}
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item.status === 'next' || item.status === 'same') {
                      return;
                    }
                    setSelectedPlanItem(item);
                  }}
                >
                  <Text variant="lg-semibold">{item.name}</Text>
                  <Stack
                    gap={4}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Text variant="2xl-semibold" color="black">
                      ₩ {item.price.toLocaleString('ko-KR')} / 월
                    </Text>
                    <Text variant="sm-medium" color="zinc_400">
                      VAT 별도
                    </Text>
                  </Stack>
                </Styled.PlanWrapper>
              );
            })}
        </Stack>
      </Stack>
    </>
  );
};

export default PricePlanList;
